import { darken, makeStyles, Theme, useTheme } from "@material-ui/core";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import createStyles from "@material-ui/core/styles/createStyles";
import classNames from "classnames";
import React, {
  ReactChild,
  ReactChildren,
  useContext,
  useEffect,
  useState
} from "react";
import { NavLink } from "react-router-dom";
import { CommonsStore, commonsStoreContext } from "../../model/CommonsStore";
import { expandedTextStyles } from "./NestedList/NestedListWrapper";
import { observer } from "mobx-react-lite";
import { routerContext } from "../../index";
import { dropRight } from "lodash";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    active: {
      "& li $activeText": {
        color: theme.palette.text.primary
      }
    },
    activeText: {
      "&:hover": {
        height: "48px"
      }
    },
    icon: {
      paddingLeft: "6px"
    },
    link: {
      textDecoration: "none",
      color: theme.palette.text.primary
    },
    nested: {
      paddingLeft: theme.spacing(8)
    },
    expandedText: expandedTextStyles(theme) as any
  })
);

export interface ListLinkPropsInternal {
  children: React.ReactElement<any> | ReactChild | ReactChildren;
  commons?: CommonsStore;
  icon?: any;
  isNested?: boolean;
  to: string;
}

export interface ListLinkProps {
  children: React.ReactElement<any> | ReactChild | ReactChildren;
  to: string;
  icon?: any;
}

const ListLinkComponent = observer((props: ListLinkPropsInternal) => {
  const classes = useStyles();
  const theme = useTheme();
  const router = useContext(routerContext);

  const [isActive, setIsActive] = useState(false);
  const [expandText, setExpandText] = useState(false);
  const { sideMenuDrawerExpanded } = useContext(commonsStoreContext);
  const { children, isNested, to, icon } = props;

  const Icon = icon;

  useEffect(() => {
    setIsActive(checkIsActivePath(router.location.pathname, to));
  }, [router.location.pathname, to]);
  const expand = () => {
    setExpandText(true);
  };
  const collapse = () => {
    setExpandText(false);
  };
  const checkIsActivePath = (path: string, to: string) => {
    const pathElements = path.split("/");

    const toElements = to.split("/");
    if (pathElements.length == toElements.length) {
      return path == to;
    } else {
      return (
        JSON.stringify(dropRight(pathElements, 1)) ===
        JSON.stringify(toElements)
      );
    }
  };

  return (
    <NavLink to={to} className={classes.link} activeClassName={classes.active}>
      <ListItem
        button={true}
        className={
          isNested
            ? classNames(classes.activeText, classes.nested)
            : classes.activeText
        }
        style={
          isActive
            ? {
                backgroundColor: darken(theme.palette.background.paper, 0.2)
              }
            : { backgroundColor: "" }
        }
        onMouseEnter={expand}
        onMouseLeave={collapse}
      >
        {Icon && (
          <ListItemIcon className={classes.icon}>
            <Icon />
          </ListItemIcon>
        )}
        {sideMenuDrawerExpanded ? (
          <ListItemText>{children}</ListItemText>
        ) : (
          <ListItemText
            className={expandText ? classes.expandedText : undefined}
          >
            {children}
          </ListItemText>
        )}
      </ListItem>
    </NavLink>
  );
});

export const ListLink = ListLinkComponent;
